import AsyncStorage from '@react-native-async-storage/async-storage';
import { Platform } from 'react-native';

const FIRST_TIME_KEY = 'paperzilla_has_logged_in';
const LAST_EMAIL_KEY = 'paperzilla_last_email';

export const hasEverLoggedIn = async (): Promise<boolean> => {
    try {
        if (Platform.OS === 'web') {
            return localStorage.getItem(FIRST_TIME_KEY) === 'true';
        } else {
            const value = await AsyncStorage.getItem(FIRST_TIME_KEY);
            return value === 'true';
        }
    } catch (error) {
        console.error('Failed to check login history:', error);
        return false;
    }
};

export const hasEverLoggedInHint = (): boolean => {
    try {
        if (Platform.OS === 'web') {
            return localStorage.getItem(FIRST_TIME_KEY) === 'true';
        }
    } catch (error) {
        console.error('Failed to read login history hint:', error);
    }

    return false;
};

export const markAsLoggedIn = async (): Promise<void> => {
    try {
        if (Platform.OS === 'web') {
            localStorage.setItem(FIRST_TIME_KEY, 'true');
        } else {
            await AsyncStorage.setItem(FIRST_TIME_KEY, 'true');
        }
    } catch (error) {
        console.error('Failed to mark user as logged in:', error);
    }
};

export const clearLoginHistory = async (): Promise<void> => {
    try {
        if (Platform.OS === 'web') {
            localStorage.removeItem(FIRST_TIME_KEY);
        } else {
            await AsyncStorage.removeItem(FIRST_TIME_KEY);
        }
    } catch (error) {
        console.error('Failed to clear login history:', error);
    }
};

// Email storage functions for returning users
export const saveLastEmail = async (email: string): Promise<void> => {
    try {
        if (Platform.OS === 'web') {
            localStorage.setItem(LAST_EMAIL_KEY, email);
        } else {
            await AsyncStorage.setItem(LAST_EMAIL_KEY, email);
        }
    } catch (error) {
        console.error('Failed to save email:', error);
    }
};

export const getLastEmail = async (): Promise<string | null> => {
    try {
        if (Platform.OS === 'web') {
            return localStorage.getItem(LAST_EMAIL_KEY);
        } else {
            return await AsyncStorage.getItem(LAST_EMAIL_KEY);
        }
    } catch (error) {
        console.error('Failed to get last email:', error);
        return null;
    }
};

export const clearLastEmail = async (): Promise<void> => {
    try {
        if (Platform.OS === 'web') {
            localStorage.removeItem(LAST_EMAIL_KEY);
        } else {
            await AsyncStorage.removeItem(LAST_EMAIL_KEY);
        }
    } catch (error) {
        console.error('Failed to clear last email:', error);
    }
};
